import { actionToTheme } from "./types";
import { checkIsNotReferrer, createBaiduChannel, detectOS, formatUTCTimestamp, getDevice, isLogin } from "./helper";
import { localAESStorage, sessionAESStorage } from "@/util/storage";
import { nanoid } from "nanoid";
import { useUserCreate } from "@/store/User";
// import { useUserIdCreate } from '../../mobileApp/store/user-id-store';
// import logger from '@handle/error/logger';
import { loggingDataState } from "@/store/DataWareHouse";
// import { v4 as uuidv4 } from 'uuid';
// import { post } from '@helper/http';
// import { IS_FROM_INDEX_PLAY } from '@components/business/GlobalNav/storage';
import { isMobileOnly } from "react-device-detect";
import { isProd } from "@/config/index";
import { post } from "@/helpers/http";
export const getCurrentTab = () => {
  // const isFromPlay = Boolean(localStorage.getItem(IS_FROM_INDEX_PLAY));
  // if (isFromPlay) return 'top';
  const currentTab = sessionAESStorage.getItem("currentTab") || "share";
  return currentTab;
};
const mainUrlList = ["app", "image", "collection", ""];
export const setCurrentTab = pathname => {
  const tabName = pathname.substring(1);
  const defaultTab = isMobileOnly ? "app" : "image";
  if (mainUrlList.includes(tabName)) {
    sessionAESStorage.setItem("currentTab", tabName || defaultTab);
  }
};
export const getClickObject = () => {
  const previousPathname = sessionAESStorage.getItem("previousPathname") || "";
  return mainUrlList.includes(previousPathname.substring(1)) ? "main" : "recommend";
};
export var LoggingAction;
(function (LoggingAction) {
  LoggingAction["REGISTRATION_POP_UP"] = "registration_pop_up";
  LoggingAction["GENERATE_SUCCESS"] = "generate_success";
  LoggingAction["GENERATE_BUTTON_CLICK"] = "generate_button_click";
  LoggingAction["OPTIMIZE_SUCCESS"] = "optimize_success";
  LoggingAction["OPTIMIZE"] = "optimize";
  LoggingAction["IMAGE_PUBLISH"] = "image_publish";
  LoggingAction["IMAGE_DOWNLOAD"] = "image_download";
  LoggingAction["APP_VISIT"] = "app_visit";
  LoggingAction["PIC_VISIT"] = "pic_visit";
  LoggingAction["PIC_LIKE"] = "pic_like";
  LoggingAction["APP_TAB"] = "app_tab";
  LoggingAction["SORTMODE_SWITCH"] = "sortmode_switch";
  LoggingAction["USERPATH"] = "userpath";
  LoggingAction["REGISTER"] = "register";
  LoggingAction["AUTOLOGIN"] = "autologin";
  LoggingAction["BANNER_CLICK"] = "banner_click";
  LoggingAction["BUILD_CLICK"] = "build_click";
  LoggingAction["BUILD_EXPLORE_CLICK"] = "build_explore_click";
  LoggingAction["SCRATCH_BUILD_CLICK"] = "scratch_build_click";
  LoggingAction["PLAY_BUTTON_CLICK"] = "play_button_click";
  LoggingAction["LANDING_BUILD_CLICK"] = "landing_build_click";
  LoggingAction["REFERRAL_BUTTON_CLICK"] = "referral_button_click";
  LoggingAction["REFERRAL_LINK_SUCCESS"] = "referral_link_success";
  LoggingAction["PROFILE_ENTER"] = "profile_enter";
  LoggingAction["RANK_VISIT"] = "rank_visit";
  LoggingAction["LOGIN_BUTTON_CLICK"] = "login_button_click";
  LoggingAction["SHARE_BUTTON_CLICK"] = "share_button_click";
  LoggingAction["SEARCH"] = "search";
  LoggingAction["SAVE_APP"] = "save_app";
  LoggingAction["FORK_APP"] = "fork_app";
})(LoggingAction || (LoggingAction = {}));
class EventTracker {
  loggingEvent(action) {
    let data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const poc = loggingDataState.getState().dataWareHouse.location;
    const geneid = loggingDataState.getState().dataWareHouse.generateid;
    const origin = loggingDataState.getState().dataWareHouse.origin;
    const rankLocation = loggingDataState.getState().dataWareHouse.rankLocation;
    const userLocation = loggingDataState.getState().dataWareHouse.userLocation;
    // const loggingDispatch = loggingDataState.getState().dispatch;
    let defaultData = false; // 是否传访问源默认参数
    let paramsData = {}; // 埋点新增属性
    let loggingData = {}; // properties新增属性
    switch (action) {
      case "registration_pop_up":
        paramsData = {
          user_id: data.user_id
        };
        loggingData = {
          isregister: data.isregister,
          location: poc
        };
        defaultData = true;
        break;
      case "generate_success":
        loggingData = {
          generateid: geneid,
          imgIds: data.imageIdList
        };
        break;
      case "optimize_success":
        loggingData = {
          pictureid: data.imgId,
          sourceId: data.sourceId
        };
        break;
      case "optimize":
        defaultData = true;
        loggingData = {
          pictureid: data.imgId
        };
        break;
      case "image_publish":
        loggingData = {
          pictureid: data.pictureid
        };
        break;
      case "image_download":
        loggingData = {
          pictureid: data.pictureid
        };
        break;
      case "app_visit":
        {
          const currentTab = getCurrentTab();
          const appid = location.pathname.substring(1) || "";
          const clickObject = getClickObject();
          loggingData = {
            current_tab: currentTab,
            appid,
            origin: data.origin,
            click_object: clickObject
          };
          break;
        }
      case "pic_visit":
        loggingData = {
          pic_id: data.pictureid,
          origin: data.origin
        };
        break;
      case "pic_like":
        loggingData = {
          pic_id: data.pictureid
        };
        break;
      case "app_tab":
        {
          loggingData = {
            presentation_mode: data.tab || "",
            current_tab: data.currentTab || ""
          };
          break;
        }
      case "sortmode_switch":
        loggingData = {
          sortmode_mode: data.sort
        };
        break;
      case "userpath":
        {
          const preUrl = document.referrer ? document.referrer : "";
          const traceId = localStorage.getItem("traceId") ? localStorage.getItem("traceId") : "";
          loggingData = {
            isnew: data.isnew,
            traceId: traceId,
            preUrl
          };
          defaultData = true;
          break;
        }
      case "register":
        {
          defaultData = true;
          paramsData = {
            user_id: data.user_id
          };
          const inviter = sessionAESStorage.getItem("invite") ? sessionAESStorage.getItem("invite") : "";
          const referralRegister = inviter !== "" ? data.user_id : "";
          loggingData = {
            inviter: inviter,
            referralRegister: referralRegister
          };
          break;
        }
      case "autologin":
        {
          defaultData = true;
          paramsData = {
            user_id: data.user_id
          };
          break;
        }
      case "banner_click":
      case "build_click":
      case "build_explore_click":
      case "scratch_build_click":
      case "play_button_click":
      case "landing_build_click":
        defaultData = true;
        break;
      case "referral_button_click":
        {
          break;
        }
      case "referral_link_success":
        {
          defaultData = true;
          break;
        }
      case "profile_enter":
        {
          loggingData = {
            userId: data.userId,
            location: userLocation
          };
          break;
        }
      case "rank_visit":
        {
          defaultData = true;
          loggingData = {
            location: rankLocation
          };
          sessionAESStorage.setItem("currentTab", "rank");
          break;
        }
      case "login_button_click":
        {
          defaultData = true;
          break;
        }
      case "share_button_click":
        {
          const currentTab = getCurrentTab();
          const typeInfo = data.picid ? {
            type: "image",
            picid: data.picid
          } : {
            type: "app"
          };
          loggingData = {
            ...typeInfo,
            current_tab: currentTab,
            object: data.object,
            appid: data.appid || "",
            object_name: data.objectName
          };
          break;
        }
      case "search":
        {
          const currentTab = getCurrentTab();
          loggingData = {
            current_tab: currentTab,
            search_content: data.searchContent,
            result_num: data.resultNum
          };
          break;
        }
      case "save_app":
        {
          loggingData = {
            appid: data.appid,
            addition: data.addition
          };
          break;
        }
      case "fork_app":
        {
          loggingData = {
            appid: data.appid
          };
          break;
        }
      // 其他类型的埋点操作
      default:
        console.warn("Unknown log type: ".concat(action));
    }
    try {
      // 检查paramsData和loggingData的缺失值
      const missingParamKey = this.lostValues(paramsData);
      const missingLoggingKey = this.lostValues(loggingData);
      // if (missingParamKey) {
      // 	logger.error('埋点', `缺少埋点信息: 参数数据缺少关键属性 ${missingParamKey}`, paramsData);
      // 	return;
      // }
      // if (missingLoggingKey) {
      // 	logger.error(
      // 		'埋点',
      // 		`缺少埋点信息: 日志数据缺少关键属性 ${missingLoggingKey}`,
      // 		loggingData,
      // 	);
      // 	return;
      // }
      // 如果数据没有缺少关键信息，则发送请求
      // if (!this.isProd || this.DEV_MODE || this.isPageEmbeddedAndNoA1()) {
      // 	return;
      // }
      let properties = {};
      if (defaultData === true) {
        properties = {
          ...this.getProperties(),
          ...loggingData
        };
      } else {
        properties = {
          ...loggingData
        };
      }
      const option = this.getOption(action, paramsData, properties);
      this.trackEvent();
      this.eventTracking(option);
      const data = JSON.stringify(option);
      return {
        data
      };
    } catch (error) {
      // logger.error('埋点', '请求发送失败:', error);
    }
  }
  initializeTrackingCount() {
    sessionStorage.setItem("trackingCount", "1");
  }
  clearTrackingCount() {
    sessionStorage.removeItem("trackingCount");
  }
  deleteBaiduChannel() {
    localAESStorage.removeItem("expandData");
    // 登录后不再删除originUrl
    // localAESStorage.removeItem(LSK.ORIGIN_URL);
  }
  delateChannel() {
    localStorage.removeItem("source");
    localStorage.removeItem("plan");
    localStorage.removeItem("createdate");
    localStorage.removeItem("traceId");
    sessionAESStorage.removeItem("inviteParam");
  }
  updateChannel() {
    let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "",
      hasUserCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isLogin() || hasUserCount) {
      this.delateChannel();
      return;
    }
    const urlParams = new URLSearchParams(searchStr);
    const sourceParam = urlParams.get("source");
    const planParam = urlParams.get("plan");
    const traceIdParam = urlParams.get("traceId");
    if (sourceParam || planParam || traceIdParam) {
      if (!isLogin()) {
        this.createChannel(searchStr);
        return;
      }
    }
    const createdate = localStorage.getItem("createdate");
    const currentTime = new Date().getTime();
    const storedTime = new Date(createdate).getTime();
    const timeDifference = currentTime - storedTime;
    if (timeDifference > 24 * 60 * 60 * 1000) {
      this.delateChannel();
    }
  }
  isPageEmbeddedAndNoA1() {
    return checkIsNotReferrer() && window.location.host !== "https://a1.art";
  }
  getOption(action) {
    let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      propertiesNew = arguments.length > 2 ? arguments[2] : void 0;
    let userId = "";
    if (params.user_id) {
      userId = params.user_id;
    }
    const option = {
      business_type: "A1",
      theme: this.getActionToTheme(action) !== null ? this.getActionToTheme(action) : "behaviour",
      action,
      distinct_id: this.generateUUID(),
      time: formatUTCTimestamp(),
      user_id: userId !== "" ? userId : isLogin() ? this.getUserId() : "",
      hrefUrl: window.location.href,
      uniqueId: this.getShortUUID(),
      sessionId: this.getUUID(),
      count: parseInt(sessionStorage.getItem("trackingCount")) || 0,
      properties: {
        user_agent: window.navigator.userAgent,
        device_type: getDevice(),
        os: detectOS(),
        screen_magnification: window.devicePixelRatio,
        screen_resolution: window.screen.width + "x" + window.screen.height,
        browser_window_size: window.innerWidth + "x" + window.innerHeight,
        userLanguage: window.navigator.language,
        originUrl: localAESStorage.getItem("originURL") || "",
        ...propertiesNew
      },
      ...params
    };
    return option;
  }
  getActionToTheme(action) {
    let theme = null;
    Object.keys(actionToTheme).forEach(item => {
      if (item.toLowerCase() == action.toLowerCase()) {
        theme = actionToTheme[item];
      }
    });
    return theme;
  }
  generateUUID() {
    return nanoid();
  }
  getShortUUID() {
    let uniqueID = localStorage.getItem("uniqueID");
    if (!uniqueID) {
      uniqueID = nanoid(24);
      localStorage.setItem("uniqueID", uniqueID);
    }
    return uniqueID;
  }
  getUUID() {
    let sessionId = sessionStorage.getItem("sessionId");
    if (!sessionId) {
      sessionId = nanoid(10);
      sessionStorage.setItem("sessionId", sessionId);
    }
    return sessionId;
  }
  getUserId() {
    var _state_userState_userId;
    const state = useUserCreate.getState();
    return ((_state_userState_userId = state.userState.userId) === null || _state_userState_userId === void 0 ? void 0 : _state_userState_userId.trim()) || "";
  }
  getProperties() {
    const {
      source = "",
      plan = "",
      traceId = ""
    } = this.getChannel();
    return {
      source: source,
      plan: plan,
      traceId: traceId,
      firstenterurl: this.getFirstVisitRoute(),
      referrerurl: this.getFirstVisitRefRoute()
    };
  }
  eventTracking(data) {
    const host = isProd ? "https://data.a1.art" : "https://aws-test-data.geesdev.com";
    try {
      // 检查是否缺少关键信息
      const missingField = this.lostDataValues(data);
      if (missingField) {
        console.error("埋点", "缺少埋点信息: ".concat(missingField), data);
        return;
      }
      // 如果数据没有缺少关键信息，则发送请求
      return post({
        url: host,
        data: data,
        config: {
          withCredentials: false
        }
      });
    } catch (error) {
      console.error("埋点", "请求发送失败:", error);
    }
  }
  createChannel(searchStr) {
    const urlParams = new URLSearchParams(searchStr);
    const sourceParam = urlParams.get("source") || "";
    const planParam = urlParams.get("plan") || "";
    const traceParam = urlParams.get("traceId") || "";
    const currentDate = new Date().toISOString();
    localStorage.setItem("source", sourceParam);
    localStorage.setItem("plan", planParam);
    localStorage.setItem("traceId", traceParam);
    localStorage.setItem("createdate", currentDate);
  }
  getChannel() {
    const source = localStorage.getItem("source") || "";
    const plan = localStorage.getItem("plan") || "";
    const traceId = localStorage.getItem("traceId") || "";
    const createdate = localStorage.getItem("createdate") || "";
    const data = {
      source,
      plan,
      createdate,
      traceId
    };
    return data;
  }
  getFirstVisitRoute() {
    const checkVisitRecord = () => {
      const visitRecord = localStorage.getItem("visitRecord");
      if (visitRecord) {
        return JSON.parse(visitRecord);
      } else {
        return null;
      }
    };
    const getCurrentTimestamp = () => {
      return Math.floor(Date.now() / 1000);
    };
    const updateVisitRecord = route => {
      const visitRecord = {
        route: route,
        timestamp: getCurrentTimestamp()
      };
      localStorage.setItem("visitRecord", JSON.stringify(visitRecord));
    };
    const getFirstVisit = () => {
      const visitRecord = checkVisitRecord();
      if (visitRecord) {
        const currentTime = getCurrentTimestamp();
        if (currentTime - visitRecord.timestamp <= 24 * 60 * 60) {
          return visitRecord.route;
        }
      }
      updateVisitRecord(window.location.pathname);
      return window.location.pathname;
    };
    const data = getFirstVisit();
    return data;
  }
  getFirstVisitRefRoute() {
    const checkVisitRecord = () => {
      const visitRecord = localStorage.getItem("visitRefRecord");
      if (visitRecord) {
        return JSON.parse(visitRecord);
      } else {
        return null;
      }
    };
    const getCurrentTimestamp = () => {
      return Math.floor(Date.now() / 1000);
    };
    const updateVisitRecord = route => {
      const visitRecord = {
        route: route,
        timestamp: getCurrentTimestamp()
      };
      localStorage.setItem("visitRefRecord", JSON.stringify(visitRecord));
    };
    const getFirstVisit = () => {
      const visitRecord = checkVisitRecord();
      if (visitRecord) {
        const currentTime = getCurrentTimestamp();
        if (currentTime - visitRecord.timestamp <= 24 * 60 * 60) {
          return visitRecord.route;
        }
      }
      updateVisitRecord(document.referrer);
      return document.referrer;
    };
    const data = getFirstVisit();
    return data;
  }
  trackEvent() {
    let trackingCount = parseInt(sessionStorage.getItem("trackingCount")) || 1;
    trackingCount++;
    sessionStorage.setItem("trackingCount", trackingCount.toString());
  }
  // private isProd: boolean;
  // private DEV_MODE: boolean;
  // constructor() {
  // 	this.isProd = isProd;
  // 	this.DEV_MODE = DEV_MODE;
  // }
  constructor() {
    this.requiredFields = ["business_type", "theme", "action", "distinct_id", "time", "sessionId", "count"];
    this.lostDataValues = obj => {
      // 深层遍历所有属性，不能为 null 或 undefined
      const deepCheck = obj => {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (obj[key] === undefined || obj[key] === null) {
              return key;
            } else if (typeof obj[key] === "object") {
              const missingField = deepCheck(obj[key]);
              if (missingField) {
                return missingField;
              }
            }
          }
        }
        return null;
      };
      // 检查深层遍历结果
      const deepCheckResult = deepCheck(obj);
      if (deepCheckResult) {
        return deepCheckResult;
      }
      // 检查 user_id 和 uniqueId 是否同时为空
      if (obj.user_id === "" && obj.uniqueId === "") {
        return "user_id 和 uniqueId 不能同时为空";
      }
      // 检查必须字段是否为空
      for (const field of this.requiredFields) {
        if (obj[field] === undefined || obj[field] === null || obj[field] === "") {
          return field;
        }
      }
      return null;
    };
    // 检查传入对象中是否存在属性值为undefined或null的属性
    this.lostValues = obj => {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (obj[key] === undefined || obj[key] === null) {
            return key;
          }
        }
      }
      return null;
    };
    if ("object" !== "undefined") {
      createBaiduChannel(window.location.search);
    }
  }
}
const eventTracker = new EventTracker();
export default eventTracker;